import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import M from 'materialize-css';
import { Redirect } from 'react-router-dom';
import Functions from '../../api/Functions';
import convertXLSXtoSafetyData from '../../utils/XLSXUtil';

const ImportPrizes = (props) => {
  const { auth } = props;
  const [prizesFromFile, setPrizesFromFile] = useState([]);
  const [showProcessText, setShowProcessText] = useState(false);

  useEffect(() => M.AutoInit(), []);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const binaryString = evt.target.result;
      const safetyDataXls = convertXLSXtoSafetyData(binaryString);
      setPrizesFromFile(organizeInBatches(safetyDataXls));
    };
    reader.readAsBinaryString(file);
  };

  const organizeInBatches = (array) => {
    const res = [];
    while (array.length) res.push(array.splice(0, 5000));
    return res;
  };

  const importPrizesFromFile = () => {
    if (showProcessText || prizesFromFile.length === 0) return;
    setShowProcessText(true);
    const prizesList = getFinalPrizesList(prizesFromFile[0]);
    importPrizes(prizesList);
  };

  const getFinalPrizesList = (prizes) => prizes.map((p) => ({ ...p, id: `${p.number}`.padStart(6, '0') }));

  const importPrizes = (prizesList) => {
    Functions.importPrizes(prizesList)
      .then(() => {
        const newPrizes = [...prizesFromFile];
        newPrizes.shift();
        setPrizesFromFile(newPrizes);
        M.toast({ html: `${newPrizes.length === 0 ? 'Finished importing' : 'Batch imported'}` });
      })
      .catch((e) => M.toast({ html: `Error: ${e.message}` }))
      .finally(() => setShowProcessText(false));
  };

  const renderFileInput = () => (
    <Fragment>
      <div>
        <h6 style={{ marginRight: 20 }}>Select file:</h6>
        {renderInstructions()}
        <input type="file" id="csv_input" accept=".csv,.xlsx,.xls" onChange={handleFileUpload} />
      </div>
      <br />
      {prizesFromFile.length > 0 && <p>Total prizes from file: {prizesFromFile.length}</p>}
      <div className="row">
        <button className="col s3 waves-effect waves-light btn-small" onClick={importPrizesFromFile}>
          Import Prizes from CSV
        </button>
        <div className="col s2">Batches to import: {prizesFromFile.length}</div>
        <div className="col s5">{showProcessText && <div>Processing...</div>}</div>
      </div>
    </Fragment>
  );

  const renderInstructions = () => (
    <div className="row">
      <div className="col s2">
        <p>1. Obligatory fields:</p>
        <ol>
          <li>number</li>
          <li>type</li>
          <li>value</li>
        </ol>
      </div>
      <div className="col s2">
        <p>2. Accepted type values:</p>
        <ol>
          <li>giftcard</li>
          <li>entries</li>
          <li>xp</li>
        </ol>
      </div>
    </div>
  );

  const renderAllPrizesFromFile = () => {
    return (
      <div>
        <div className="row">
          <div className="col s4">Number</div>
          <div className="col s4">Type</div>
          <div className="col s4">Value</div>
        </div>
        <div>{prizesFromFile && prizesFromFile.length > 0 ? prizesFromFile.map((prizes) => renderPrizes(prizes)) : <div />}</div>
      </div>
    );
  };

  const renderPrizes = (prizes) => (prizes && prizes.length > 0 ? prizes.map((p) => prize(p)) : null);

  const prize = (prize) => (
    <div className="row" key={prize.number} style={{ backgroundColor: '#f8f8f8', padding: 10, marginBottom: 5 }}>
      <div className="col s4">{prize.number}</div>
      <div className="col s4">{prize.type}</div>
      <div className="col s4">{prize.value}</div>
    </div>
  );

  if (!auth.uid) return <Redirect to="/signin" />;
  return (
    <div className="container">
      <div className="title-section">Import Prizes from File</div>
      {renderFileInput()}
      {renderAllPrizesFromFile()}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect(), connect(mapStateToProps))(ImportPrizes);
